import { ReactNode, useId } from 'react'
import {
  Checkbox,
  CheckboxProps,
  CheckedState,
  Label,
  ParagraphProps,
  SizeTokens,
  XStack,
  XStackProps,
  YStack,
} from 'tamagui'
import { CheckRegular, MinusRegular } from '@tamagui-extras/core'

export type CheckboxFieldProps = XStackProps & {
  checkboxProps?: CheckboxProps
  label?: ReactNode
  onChange?: (state: CheckedState) => void
  value?: boolean
  error?: boolean
  helperText?: ReactNode
  helperTextProps?: ParagraphProps
  size?: SizeTokens
  required?: boolean
}

export function CheckboxField({
  label,
  onChange,
  error,
  helperText,
  size = '$3',
  value,
  required,
  theme,
  helperTextProps,
  checkboxProps,
  ...stackProps
}: CheckboxFieldProps) {
  const id = useId()
  return (
    <YStack jc="center" {...stackProps}>
      <XStack ai="center" jc="flex-start" gap="$3">
        <Checkbox
          id={id}
          {...checkboxProps}
          defaultChecked={value || checkboxProps?.defaultChecked}
          size={size}
          onCheckedChange={(checked) => {
            if (typeof onChange === 'function') {
              onChange(checked)
            }
          }}
          borderColor={error ? '$red7' : '$black'}
          borderRadius={4}
          borderWidth={1}
        >
          <Checkbox.Indicator>
            {checkboxProps?.checked === 'indeterminate' ? <MinusRegular /> : <CheckRegular />}
          </Checkbox.Indicator>
        </Checkbox>
        {label && (
          <Label size="$1" htmlFor={id}>
            {label}
          </Label>
        )}
      </XStack>
    </YStack>
  )
}
